import React from "react";
import { View, StyleSheet } from "react-native";
import NtTouchableEffect from "../../../components/NtTouchableEffect";
import NtText from "../../../components/NtText";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtActivityIndicator from "../../../components/NtActivityIndicator";

function NtSectionButton({
  containerStyle,
  color = "red",
  title = "Button",
  icon,
  loading = false,
  onPress,
}) {
  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle, { borderColor: color }]}
      onPress={onPress}
    >
      <NtText style={[styles.text, { color: color }]}>{title}</NtText>
      {icon && (
        <NtMaterialIcon
          containerStyle={{ marginLeft: 6 }}
          name={icon}
          color={color}
          size={18}
        />
      )}
      {loading && (
        <NtActivityIndicator containerStyle={{ marginLeft: 10 }} size={15} />
      )}
    </NtTouchableEffect>
  );
}

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: "red",
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: 4,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    fontSize: 11,
    fontWeight: "600",
    color: "red",
  },
});

export default NtSectionButton;
